import { ButtonIcon, NextArrowIcon, PreviousArrowIcon } from 'canoe';
import React from 'react';

import { PaletteAppearance } from 'craft/state/menus/reducer';

interface PinnedToggleProps {
  pinnedAppearance: PaletteAppearance;
  onToggle: () => void;
}

export const PinnedToggle = ({ pinnedAppearance, onToggle }: PinnedToggleProps) => {
  const Icon = pinnedAppearance === PaletteAppearance.PINNED ? PreviousArrowIcon : NextArrowIcon;

  return (
    <ButtonIcon
      data-cy="pinned-toggle"
      size="xsmall"
      color="contrast"
      radius="xsmall"
      icon={Icon}
      onClick={onToggle}
      ml="xs"
      active={pinnedAppearance === PaletteAppearance.PINNED}
    />
  );
};
